const SITE_URL = 'https://linkpool.com'

export function createBlogBreadcrumbSchema(post) {
  const items = [
    { name: 'Home', url: SITE_URL },
    { name: 'Blog', url: `${SITE_URL}/blog` }
  ]

  if (post) {
    items.push({
      name: post.title,
      url: `${SITE_URL}/blog/${post.slug}`
    })
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  }
}

export function createBlogPostingSchema({
  title,
  description,
  heroImage,
  date,
  author,
  slug
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: title,
    description,
    image: heroImage?.startsWith('http')
      ? heroImage
      : `${SITE_URL}${heroImage}`,
    datePublished: date,
    author: {
      '@type': 'Person',
      name: author
    },
    publisher: {
      '@type': 'Organization',
      name: 'LinkPool',
      url: SITE_URL
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/blog/${slug}`
    }
  }
}

export function createBlogListSchema(posts) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: 'LinkPool Blog',
    description:
      'Latest news and insights from LinkPool about Web3 infrastructure, liquid staking, and onchain finance.',
    url: `${SITE_URL}/blog`,
    publisher: {
      '@type': 'Organization',
      name: 'LinkPool',
      url: SITE_URL
    },
    blogPost: posts.map(({ frontmatter }) => ({
      '@type': 'BlogPosting',
      headline: frontmatter.title,
      datePublished: frontmatter.date,
      url: `${SITE_URL}/blog/${frontmatter.slug}`
    }))
  }
}
